import React from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { CurriculumEdit } from "../curricula/CurriculumEdit";
import styles from "./CurriculaDetail.module.css";

interface Params {
  id: string;
}

interface Location {
  item: any; //TODO
}

const CurriculaDetail = () => {
  let { id } = useParams<Params>();
  const { state } = useLocation<Location>();
  console.log("state", state);
  const history = useHistory();

  const handleEdited = (e: any) => {
    e.preventDefault();
    history.goBack();
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.backBtn} onClick={handleEdited}>
          {"< Go back"}
        </div>
        <CurriculumEdit item={state.item} action={handleEdited} />
      </div>
    </>
  );
};

export default CurriculaDetail;
